import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ValidationErrors, Validators } from '@angular/forms';
//import { CadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/cadenas.service';
//import { CatalogoCadenasService } from 'src/app/aplicaciones-modulos/presupuesto-sellout/services/catalogo-cadenas.service';
import { CommonFormService } from 'src/app/shared/utils/common-form.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import {
  LfsaBotonEditarGridComponent
} from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

import { indicadoresVivosModulo } from '../../diccionarios/indicadoresVivosModulo';
import { IndicadoresVivosVModel, IndicadoresVivosVModelInterface } from '../../models/indicadoresVivosVModel';
import { CatalogoIndicadoresService } from '../../services/catalogo-indicadores.service';
import { IndicadoresVivosService } from '../../services/indicadores-vivos.service';
import { VersionesService } from '../../services/versiones.service';
import { DireccionesUsuariosService } from '../../services/direcciones-usuarios.service';
import { RolModel } from 'src/app/aplicaciones-modulos/vmi/services/administracion/vmi-rolModel';

@Component({
  selector: 'app-mantenedor-indicadores',
  templateUrl: './mantenedor-indicadores.component.html',
  styleUrls: ['./mantenedor-indicadores.component.css']
})
export class MantenedorIndicadoresComponent implements OnInit {

  tituloCard: string = 'Mantenedor Presupuesto';
  tituloForm: string = 'Lista De Presupuesto';

  formulario: FormGroup;
  FormFiltros: FormGroup;

  mostrarFormulario: boolean = false;
  editableForm: boolean = false;

  rowData: any[] = [];
  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  columnDefs: any[];
  rowSelection: any;

  //buscador grid
  textoBuscar: string;

  //componentes para apuntar a diccionario
  DAT_BTNS;
  DAT_MSG;
  DAT_BTNCSS;

  textBoton: string;

  //para cargar con el grid
  listaVacia: boolean = true;
  loading: boolean = false;
  modulo: any = {};
  GUARDAR: string = 'guardar';

  modelGrid: IndicadoresVivosVModelInterface;
  cmbTipoDocumento: { clave: number; valor: string; }[];
  cmbMeses: { clave: number; valor: string; }[];

  dolaresMayorQueVentaBruta = false;
  ventaBrutaMenorQueDolares = false;

  private DOC_CANAL_MODERNO: number = 10;
  private DOC_CANAL_TRADICIONAL: number = 20;
  private STATUS_UPDATE: string = "420";
  mesDescripcion: string = '';

  cmbTipoDePresupuesto: any[] = [
    { clave: 1, valor: 'LE-COMERCIAL' },
    { clave: 2, valor: 'LE-COMISIONES' }
  ]

  readonly CURRENT_YEAR   = new Date().getFullYear().toString();
  readonly CURRENT_MONTH  = (new Date().getMonth())+1;
  readonly LOGIN_ACTUAL = JSON.parse(localStorage.getItem('datosUsuarioLogin'));
  usuario;
  requiereCliente = true;

  constructor(
    private fb: FormBuilder,
    private commonFormService: CommonFormService,
    private _utils: UtilsService,
    private _indicadores: IndicadoresVivosService,
    private _catalogo: CatalogoIndicadoresService,
    private _versiones: VersionesService,
    private _direccionesUsuarios: DireccionesUsuariosService,
  ) { }

  ngOnInit() {

    this.modulo = indicadoresVivosModulo;
    this.DAT_BTNS = this.modulo.button.buttonsNombre;
    this.DAT_MSG = this.modulo.mensajes;
    this.DAT_BTNCSS = this.modulo.button.buttonsCss;
    
    this.cmbTipoDocumento = this._catalogo.catalogoTipoDocumento();
    this.cmbMeses = this._catalogo.catalogoMeses();
    const innClase = new IndicadoresVivosVModel();
    this.modelGrid = innClase.devolverGrid();
    this.usuario = this.LOGIN_ACTUAL.login2;

    this.formulario = this.fb.group({
      anio: ['', [Validators.required, 
                  Validators.min(2021), 
                  Validators.max(new Date().getFullYear()+1),
                  Validators.pattern('^[0-9]{4}$')
                ]],
      codigoArticulo: ['', [Validators.required, Validators.maxLength(10)]],
      codigoCliente: ['0', [Validators.maxLength(10)]],
      codigoVendedor: ['', [Validators.required, Validators.maxLength(10)]],
      dolares: ['', [Validators.required, Validators.min(1), Validators.maxLength(8)]],
      kilos: ['', [Validators.required, Validators.min(0), Validators.maxLength(8)]],
      mes: ['', [Validators.required]],
      tipo: ['', [Validators.required]],
      cajas: ['', [Validators.required, Validators.min(0), Validators.maxLength(8)]],
      mtv: ['', [Validators.required, Validators.min(1), Validators.maxLength(8)]],
      version: ['', []],
      estado: ['', []],
      tipoPresupuesto: ['', [Validators.required]],
      ventaBruta: ['', []],
      nombreCliente: ['', []],
      nombreVendedor: ['', []],
      nombreArticulo: ['', []],
      fechaHoraSys: ['', []],
      mesDescripcion: ['', []],
      codigoVendedorDestino: ['', []],
      vendedorDestino: ['', []],
      descripcionTipoPresupuesto: ['', []],
      descripcionVersion: ['', []],
      contenedor: ['', []],
      usuario: [this.usuario, [Validators.required]],
      descripcionCanal: ['', []],
      idGrupoPrecio: ['', []],
      descripcionGrupoPrecio: ['', []],
      idGrupoPrecioDestino: ['', []],
    });

    this.FormFiltros = this.fb.group({
      anio: [this.CURRENT_YEAR],
      mes : [this.CURRENT_MONTH, [Validators.required]],
    });

    this.cargarGridcomponent();
    //this.getIndicadores();
    this.getIndicadoresMesAnio(null);
    this.getVersiones();
    // console.log("listaDeVersiones", this.listaDeVersiones)
    // this.formulario.get('version').setValue(this.listaDeVersiones.filter(t=>t.estado ==='A')[0].id);

    this.formulario.get('mtv').valueChanges.subscribe((resp) => {
        this.getFormValidationErrors();
      });

    this.formulario.get('dolares').valueChanges.subscribe((resp) => {
        if (parseInt(resp) > parseInt(this.formulario.get('ventaBruta').value)) {
          this.dolaresMayorQueVentaBruta = true;
        } else this.dolaresMayorQueVentaBruta = false;
        if (parseInt(this.formulario.get('ventaBruta').value) < parseInt(resp)) {
          this.ventaBrutaMenorQueDolares = true;
        } else this.ventaBrutaMenorQueDolares = false;
      });

    this.formulario.get('ventaBruta').valueChanges.subscribe((resp) => {
        if (parseInt(this.formulario.get('dolares').value) > parseInt(resp)) {
          this.dolaresMayorQueVentaBruta = true;
        } else this.dolaresMayorQueVentaBruta = false;
        if (parseInt(resp) < parseInt(this.formulario.get('dolares').value)) {
          this.ventaBrutaMenorQueDolares = true;
        } else this.ventaBrutaMenorQueDolares = false;
      });
      
    this.FormFiltros.get('mes').setValue(this.CURRENT_MONTH);

    this.FormFiltros.get('mes').valueChanges.subscribe((mes) => {
      console.log("Mes de busqueda para el grid ", mes);
      this.getIndicadoresMesAnio(mes);
    });

    this._direccionesUsuarios.getDireccionesUsuarios().subscribe((res: any[]) => {
      if(res) 
        this.cmbTipoDocumento = res.filter(e => e.codigoUsuario == this.usuario);
        res.map(e=> {e.nombreCanalVenta = e.codigoDireccion + " - " + e.nombreCanalVenta;  return e;});
    }, (err) => { this.cmbTipoDocumento = []; });

  }

  getFormValidationErrors() {

    console.log('%c ==>> Validation Errors: ', 'color: red; font-weight: bold; font-size:25px;');

    let totalErrors = 0;

    Object.keys(this.formulario.controls).forEach(key => {
      const controlErrors: ValidationErrors = this.formulario.get(key).errors;
      if (controlErrors != null) {
        totalErrors++;
        Object.keys(controlErrors).forEach(keyError => {
          console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
        });
      }
    });

    console.log('Number of errors: ', totalErrors);
  }


  /* FUNCIONES */
  changeTipoDocumento() {
    const tipo = this.formulario.get('tipo').value;
  /*    
    this.formulario.get('codigoCliente').clearValidators();

    this.formulario.get('codigoCliente').setValue('0');
    //this.formulario.get('codigoCliente').setValue('0');
    if (tipo === this.DOC_CANAL_MODERNO.toString()) {
      this.requiereCliente = false;
      this.formulario.get('codigoCliente').setValidators([Validators.required, Validators.pattern('^[0-9]{9}$')]);
      this.formulario.get('codigoCliente').setValue('');
    }
  ¨*/
  }

  cargarGridcomponent() {
    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };
    //// cellStyle: this.changeCellColor.bind(this),

    this.columnDefs = [
      { filter: true, width: 120, field: 'descripcionVersion', headerName: 'Versión' },
      { filter: true, width: 150, field: 'descripcionTipoPresupuesto', headerName: 'Tipo de presupuesto' },
      { filter: true, width: 120, field: 'anio', headerName: 'Año' },
      { filter: true, width: 120, field: 'mesDescripcion', headerName: 'Mes' },
      {
        headerName: 'Canal',
        field: 'tipo',
        sortable: true,
        width: 160,
        filter: true,
        valueGetter: function (e) {
          return (e.data.tipo +" - "+ e.data.descripcionCanal);
        }
      },
      { sortable: true, filter: true, width: 150, headerName: 'Cod.Vendedor', field: 'codigoVendedor' },
      { sortable: true, filter: true, width: 250, headerName: 'Nom.Vendedor', field: 'nombreVendedor' },
      { sortable: true, filter: true, width: 150, headerName: 'Cod.Cliente', field: 'codigoCliente' },
      { sortable: true, filter: true, width: 250, headerName: 'Nom.Cliente', field: 'nombreCliente' },
      { sortable: true, filter: true, width: 220, headerName: 'Cod.Material', field: 'codigoArticulo' },
      { sortable: true, filter: true, width: 300, headerName: 'Nom.Material', field: 'nombreArticulo' },
      { sortable: true, filter: true, width: 150, field: 'cajas' },
      { sortable: true, filter: true, width: 150, field: 'kilos' },
      { sortable: true, filter: true, width: 150, field: 'mtv' },
      { sortable: true, filter: true, width: 150, field: 'dolares' },
      { sortable: true, filter: true, width: 150, field: 'ventaBruta' },
      { sortable: true, filter: true, width: 150, field: 'usuario' },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        pinned: 'right',
        cellRendererParams: {
          onClick: this.editar.bind(this),
          label: this.DAT_BTNS.editar,
          colorBoton: this.DAT_BTNCSS.warning
        }
      },
      {
        headerName: '',
        cellRenderer: 'buttonRenderer',
        width: 150,
        pinned: 'right',
        cellRendererParams: {
          onClick: this.eliminar.bind(this),
          label: this.DAT_BTNS.eliminar,
          colorBoton: this.DAT_BTNCSS.danger
        }
      },
    ];

    this.rowSelection = 'multiple';
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.textoBuscar);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  nuevo() {
    this.getVersiones();
    this.commonFormService.abrirFormularioParaGuardar(this);
    this.textBoton = this.DAT_BTNS.guardar;
    this.tituloForm = 'Guardar Presupuesto';
    this.formulario.get('usuario').setValue(this.usuario);
  }

  editar({ rowData }) {
    console.log("editar", rowData);
    // debugger
    this.mesDescripcion = rowData.mesDescripcion;
    this.formulario.reset();
    
    /*
    if (rowData.tipo === this.DOC_CANAL_MODERNO) {
      this.formulario.get('codigoCliente').setValidators([Validators.required]);
      this.formulario.get('codigoCliente').setValue('');
    } else /*if (rowData.tipo === this.DOC_CANAL_TRADICIONAL) {
      this.formulario.get('codigoCliente').clearValidators();
      this.formulario.get('codigoCliente').setValue('');
    }
   
    const obj = {
      anio: rowData.anio,
      codigoArticulo: rowData.codigoArticulo.trim(),
      codigoCliente: rowData.codigoCliente.trim(),
      codigoVendedor: rowData.codigoVendedor.trim(),
      contenedor: rowData.contenedor,
      mes: rowData.mes,
      tipo: rowData.tipo,
      kilos: (rowData.kilos === undefined) ? 0 : rowData.kilos,
      cajas: (rowData.cajas === undefined) ? 0 : rowData.cajas,
      dolares: (rowData.dolares === undefined) ? 0 : rowData.dolares,
      mtv: (rowData.mtv === undefined) ? 0 : rowData.mtv,
      estado: (rowData.estado === undefined) ? 0 : rowData.estado,
      version: (rowData.version === undefined) ? 0 : rowData.version,
      tipoPresupuesto: (rowData.tipoPresupuesto === undefined) ? 0 : rowData.tipoPresupuesto,
      ventaBruta: (rowData.ventaBruta === undefined) ? 0 : rowData.ventaBruta,

      nombreCliente: "BUSTAMANTE RAMOS SEBASTIAN ALEJANDR",
      nombreVendedor: "ELIZALDE ESMERALDAS MARIA JOSE",
      nombreArticulo: "ACT SABROSON S FDA*600ML*15 EAN",
      fechaHoraSys: "2023-11-26T22:55:53.495333",
      mesDescripcion: "01-ENERO",
      codigoVendedorDestino: null,
      vendedorDestino: null,
      descripcionTipoPresupuesto: "LE_COMISIONES"
    }*/
    
    rowData.usuario = rowData.usuario == null ? this.usuario : rowData.usuario;
    let { pk, ...editar } = rowData;
    this.formulario.setValue(editar);

    document.getElementById('buttonAbrirModal').click();
  }

  acciones(event) {
    // debugger
    if (event === this.GUARDAR) {
      if (this.editableForm) {
        this.actualizar();
      } else {
        this.guardar();
      }
    } else {
      this.limpiarRegresar();
    }
  }

  limpiarRegresar() {
    this.mostrarFormulario = false;
    this.tituloCard = 'Mantenedor Presupuesto';
    this.tituloForm = 'Lista De Presupuesto';
  }

  /** SERVICIOS */
  getIndicadores() {
    this.listaVacia = true;
    this.loading = true;
    this._indicadores.getAllIndicadores().subscribe((res: IndicadoresVivosVModel[]) => {
      this.loading = false;
      this.listaVacia = (res.length === 0) ? true : false;
      this.rowData = res;
      console.log("this.rowData", this.rowData)
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this.rowData = [];
    });
  }

  eliminar({ rowData }) {
/*
    this.formulario.setValue(rowData);

    let form = this.formulario.value;
    form.contenedor = "   ";
    form.codigoVendedor = form.codigoVendedor.trim();
    form.codigoCliente = form.codigoCliente.trim();
    form.codigoArticulo = form.codigoArticulo.trim();
*/
    this.loading = true;

    this._utils.confirmarSincronoPromesa({
      title: this.DAT_MSG.eliminar,
      text: rowData.id,
      action: this.DAT_BTNS.eliminar,
      funcion: this._indicadores.deleteIndicadores(rowData),
    })
      .then((res: any) => {
        this.gridApi.updateRowData({ remove: this.gridApi.getSelectedRows() });
      })
      .catch((error) => {
        this.loading = false;
      });

  }

  guardar() {
    let data = this.formulario.value;
    data.version = this.listaDeVersiones.id;
    let mesActualizacion = this.formulario.get('mes').value;
    if(data.codigoCliente == "" || data.codigoCliente == null) data.codigoCliente = 0;

    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.guardar,
        text: '',
        action: this.DAT_BTNS.guardar,
        funcion: this._indicadores.saveIndicadores(data),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      //this.getIndicadores();
      this.getIndicadoresMesAnio(mesActualizacion);
    }).catch((err) => {
      if (err.error.key === this.STATUS_UPDATE) {
        this.actualizarRegistroExistente();
      }
    });
  }

  actualizar() {

    let form = this.formulario.value;
    //form.contenedor = '';
    let mesActualizacion = this.formulario.get('mes').value;

    this._utils.confirmarSincronoPromesaNormal(
      {
        title: this.DAT_MSG.actualizar,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._indicadores.updateIndicadores(form),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.formulario.reset();
      //this.getIndicadores();
      this.getIndicadoresMesAnio(mesActualizacion);
      document.getElementById('cerrarModal').click();
    }).catch((err) => {
      // this._utils.mensajeErroToast(err.error.message, 5000);
      console.log(err);
    });
  }

  actualizarRegistroExistente() {
    let mesActualizacion = this.formulario.get('mes').value;
    this._utils.confirmarSincronoPromesaNormal(
      {
        title: `El registro ya se encuentra registrado, Desea actualizar nuevamente el registro.`,
        text: '',
        action: this.DAT_BTNS.actualizar,
        funcion: this._indicadores.updateIndicadores(this.formulario.value),
        loading: true,
        context: this,
      }
    ).then((res: any) => {
      this.limpiarRegresar();
      this.formulario.reset();
      this.getIndicadoresMesAnio(mesActualizacion);
      //this.getIndicadores();
    }).catch((err) => {
      // this._utils.mensajeErroToast(err.error.message, 5000);
      console.log(err);
    });
  }

  downloadDataCsv() {
    let data: any = [];
    let cabecera: any[] = [['Anio', 'Mes', 'Cod.Vendedor', 'Nom.Vendedor', 'Cliente', 'Nom.Cliente', 'Cod.Articulo', 'Articulo', 'Cajas', 'Dolares', 'Kilos', 'MTV', 'Usuario']];
    let clonData = this.rowData.map((x) => Object.assign({}, x));
    clonData.forEach((e) => {
      data.push(
        {
          anio: e.anio,
          mesDescripcion: e.mesDescripcion,
          codigoVendedor: e.codigoVendedor,
          nombreVendedor: e.nombreVendedor,
          codigoCliente: e.codigoCliente,
          nombreCliente: e.nombreCliente,
          codigoArticulo: (e.codigoArticulo === undefined) ? '' : e.codigoArticulo.trim,
          nombreArticulo: e.nombreArticulo,
          cajas: e.cajas,
          dolares: e.dolares,
          kilos: e.kilos,
          mtv : e.mtv,
          usuario: e.usuario
        }
      );
    });
    let name: string = "reporte-mantenedor.csv";
    this._utils.exportCSV(cabecera, data, name);
    this._utils.mensajeOKToast('El archivo csv se exportó correctame.');
  }

  keyOnly2deciamls(event: any) {
    let valor = null;
    
    if(this.formulario.get("ventaBruta").value != null)
      {
        valor = this.formulario.get("ventaBruta").value.toString();
      }

    console.log("keyOnly2deciamls", event);
    console.log("keyOnly2deciamls", valor);

    var charCode = event.which ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57))
      return false;

    if (valor != null) {
      if (valor.indexOf('.') >= 0) {
        var dotPos = valor.split(".");
        if (dotPos[1].length > 0) {
          if (dotPos[1].length >= 2) {
            return false;
          }
        }
      }
    }

    return true;


    // if ((event.which != 46 || $(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
    //      if((event.which != 46 || $(this).val().indexOf('.') != -1)){
    //       alert('Multiple Decimals are not allowed');
    //     }
    //     event.preventDefault();
    //  }
    //  if(this.value.indexOf(".")>-1 && (this.value.split('.')[1].length > 1))		{
    //       alert('Two numbers only allowed after decimal point');
    //       event.preventDefault();
    //   }
  }

  listaDeVersiones;

  getVersiones() {
    this.loading = true;
    this._versiones.getVersionActiva().subscribe((res: any) => {
      console.log("getVersionActiva()", res)
      this.loading = false;
      this.listaDeVersiones = res;
      this.formulario.get('descripcionVersion').setValue(this.listaDeVersiones.version + " - " + this.listaDeVersiones.nombre);
    }, (err) => {
      this.loading = false;
      this.listaDeVersiones = '';
    });
  }

  getIndicadoresMesAnio(mes: string | null) {
    this.loading = true;
    let currentMonth : string = this.CURRENT_MONTH.toString();
    this.rowData = [];

    if(mes){ currentMonth = mes; }
    
    this._indicadores.getPresupuestoVentas(this.CURRENT_YEAR, currentMonth, currentMonth, '0', '0').subscribe((res: any) => {
      this.rowData = res;
      this.listaVacia = this.rowData.length === 0 ? true : false;
    }, (err) => {      
      this.listaVacia = true;
      this._utils.mensajeErroToast(err.error.message);
    });

    this.loading = false;
  }

}